import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const vsHeaderStyles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.primaryDark,
    borderRadius: theme.borderRadius.xl,
    paddingVertical: 4,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    marginBottom: 5,
    gap: 12,
  },
  side: {
    flex: 1,
    alignItems: 'center',
    gap: 2,
  },
  tile: {
    width: 34,
    height: 34,
    borderRadius: 9,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  youTile: {
    backgroundColor: theme.primary + '2E',
  },
  // Same purple wash as the "You" tile — a plain black panel read as "off" next to the lavender one.
  rivalTile: {
    backgroundColor: theme.primary + '2E',
  },
  center: {
    flexShrink: 0,
    alignItems: 'center',
  },
  vs: {
    fontSize: 14,
    fontWeight: '800',
    letterSpacing: 1.5,
    color: theme.white,
  },
  h2h: {
    marginTop: 1,
    fontSize: 10.5,
    fontWeight: '600',
    color: 'rgba(255,255,255,0.72)',
    textAlign: 'center',
    maxWidth: 120,
  },
  name: {
    fontSize: 11,
    fontWeight: '700',
    color: theme.white,
    maxWidth: 110,
  },
});
